import React from "react";
import "../../styles/home.css";
import { Box, Grid, Typography } from "@mui/material";
import img1 from "../../images//Banner/bannerimg.png";
import searchIcon from "../../images/Banner/searchicon.png";
import Navbar from "../Navbar";
import { ArrowForwardIos } from "@mui/icons-material";

export default function Banner() {
  return (
    <>
      <Box className="homeBanner">
        <Box pt={4}>
          <Box
            sx={{
              background: 'linear-gradient(305deg, #F2F4FB 0%, #EFF2FA 25.93%, #E8EDF9 67.2%, #C8D8F1 100%)'
            }}>
            <Navbar />
          </Box>
          <Box mt={8}>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "start",
                    flexDirection: "column",
                    height: "100%",
                    fontFamily: "Inter",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        color: "#3665D0",
                      }}
                      className="subHeading2Mid"
                    >
                      Best Job Place
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: 700,
                        fontSize: "55px",
                        lineHeight: "120%",
                        display: "block",
                        marginTop: "1%",
                      }}
                    >
                      The Easiest Way to Get Your{" "}
                      <span style={{ color: "#3665D0" }}>New Job</span>{" "}
                    </Typography>
                    <Typography className="homeBanner-span4 text2Mid" pt={1}>
                      Each month, more than 3 million job seekers turn to website
                      in their search for work, making over 140,000 applications
                      every single day
                    </Typography>
                  </Box>
                  <Box sx={{ width: "100%", mt: "5%" }}>
                    <Box sx={{ position: "relative", width: "96%" }}>
                      <form>
                        <input
                          type="text"
                          required
                          placeholder="Job title, keywords....."
                          className="homeBanner-input"
                        />
                        <img
                          src={searchIcon}
                          className="homeBanner-searchIcon"
                          alt="icon"
                        />
                        <button type="submit" className="homeBanner-searchBtn">
                          Search
                        </button>
                      </form>
                    </Box>
                    <span className="homeBanner-span5 text2Mid">
                      Suggested Tags:
                      <span className="homeBanner-span6 text2Mid">
                        Engineering, Marketing, Ui/UX Designer, Data Analyst,
                        Programming
                      </span>
                    </span>
                  </Box>
                  <Box>
                    {" "}
                    <Box className="homeBanner_col-div-2">
                      <span className="homeBanner-span7">
                        Lorem ipsum dolor sit amet consectetur. Duis lacinia
                        tellus ac malesuada dictumst
                      </span>
                      <a className="text1Bold" href="/" style={{ display: 'flex', width: '70%', height: '50px', justifyContent: 'center', alignItems: 'center', color: '#2544EE', background: '#FFFFFF', boxShadow: '0px 2px 4.5px rgba(0, 0, 0, 0.160784)', borderRadius: '10px', gap: 4, textDecoration: 'none' }}>
                        <Typography
                          className="text1Bold"
                        >
                          Build Your Resume With Us
                        </Typography>
                        <ArrowForwardIos className="subHeading1Bold" />
                      </a>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item md={6}>
                <Box>
                  <img
                    src={img1}
                    alt="bannerCouple"
                    className="homeBanner-couple_img"
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
}
